import React, { useEffect, useImperativeHandle } from 'react';
import { Button } from '../StyledComponents';
import './Alert.scss';

const Alert = React.forwardRef((props,ref) => {
    const [ visible, setVisible ] = React.useState(false)//알럿 렌더링 여부
    const [ title, setTitle ] = React.useState('')//제목
    const [ subTitle, setSubTitle ] = React.useState('')//부제목
    const [ subWarnTitle, setSubWarnTitle ] = React.useState('')//경고 문구
    const [ isCancel, setIsCancel ] = React.useState(false)//취소 버튼 유무
    const [ confirmText, setComfirmText ] = React.useState('확인')//확인 버튼 문구
    const [ isConfirm, setIsConfirm ] = React.useState(true)//확인 버튼 유무
    const [ cancelText, setCancelText ] = React.useState('닫기')//취소 버튼 문구
    const [ onConfirm, setOnConfirm ] = React.useState(null)
    const [ config, setConfig ] = React.useState(null)

    //function forwarding
    useImperativeHandle( ref, () => ({
        showAlert: (config) => {
            showAlert(config)
        },
        hideAlert: () => {
            hideAlert()
        }
    }))

    const hideAlert = () => {
        setVisible(false)
    }

    const showAlert = (config) => {
        setTitle(config.title)
        setSubTitle(config.subTitle)
        setIsCancel(config.isCancel)
        setComfirmText(config.confirmText)
        setIsConfirm(config.isConfirm)
        setCancelText(config.cancelText)
        setSubWarnTitle(config.subWarnTitle)
        setConfig(config)
        setVisible(true)
    }

    if( !visible ) return null
    else{
        return (
            <div className='alert'>
                <div className='alert-wrapper'>
                    <div className='alert-content'>
                        <p className='title'>{title}</p>
                        {
                            ( typeof subTitle !== 'undefined' && subTitle !== '') ?
                            <p className='sub-title'>{subTitle}</p>
                            : null
                        }
                        {
                            ( typeof subWarnTitle !== 'undefined' && subWarnTitle !== '') ?
                            <p className='sub-title' style={{ color : '#f95f53'}}>{subWarnTitle}</p>
                            : null
                        }
                        <div className='btn-row'>
                            {
                                isCancel ?
                                <Button variant={'sub'} style={{ width : 122, paddingTop : 16, paddingBottom : 16 }} onClick={() => hideAlert()}>
                                    {cancelText}
                                </Button>
                                : null
                            }

                            {
                                isConfirm ?
                                <Button variant={'main'} style={{ width : 122, paddingTop : 16, paddingBottom : 16, marginLeft : 24 }} onClick={() => config.onConfirm() }>
                                    {confirmText}
                                </Button>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
})

export default Alert;